import { Grid } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useThemeContext } from '../../contexts/BaseThemeContextProvider';
const app_co = process.env.REACT_APP_COMPANY;

const MainLogo = () => {
  const { theme } = useThemeContext();
  return (
    <Grid
      item
      xs={4}
      sx={{
        paddingLeft: '0px',
        display: 'flex',
        alignItems: 'initial',
        '&.MuiGrid-item': {
          paddingTop: { md: '10px', sm: '16px' },
        },
      }}
    >
      <Link
        to={app_co === 'frost' ? '/' : 'https://www.relentlesshealth.com/'}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          textDecoration: 'none',
          paddingLeft: '0px',
          verticalAlign: 'middle',
        }}
      >
        <img src={theme.images.logo.src} alt="wellness logo" className="logo" />
      </Link>
    </Grid>
  );
};

export default MainLogo;
